import React, { Component, Fragment } from "react";
import Time from "react-time-format";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
import NumberFormat from "react-number-format";
import KurdishSoraniNumbersToWords from "kurdish-numbers-to-words/Sorani.js";
import n2wordsEN from "n2words/lib/i18n/AR.mjs";
export class PrintViewTakemoney extends Component {
 render() {
  const {
   change_Lang,
   take_money_view,
   primary_logo_bill,
   lang,
   footer_logo_bill,
  } = this.props;
  let numberWordsSorani =
   take_money_view.Amount !== ""
    ? KurdishSoraniNumbersToWords.convert(take_money_view.Amount)
    : 0;
  let numWords1 =
   take_money_view.Amount !== undefined && take_money_view.Amount !== null
    ? n2wordsEN(parseFloat(take_money_view.Amount.toString().replace(/,/g, "")))
    : 0;
  return (
   <Fragment>
    <br />
    <br /> <br />
    <br />
    <br />
    <br /> <br />
    <br />
    <br />
    <div>
     <div class="row fkr mt-1">
      <div class="col-3">
       <p
        style={{
         fontSize: "24px",
         color: "#000",
         textAlign: "right",
         fontWeight: "bold",
        }}
        class=" text-uppercase"
       >
        &nbsp;&nbsp;{change_Lang("date")} &nbsp;:&nbsp;
        <Time
         value={take_money_view.createdAt}
         format="YYYY-MM-DD"
         style={{
          fontSize: "21px",
          color: "#000",
          fontWeight: "bold",
         }}
        />
       </p>
      </div>
      <div class="col-6 d-flex justify-content-center">
       <p
        style={{
         fontSize: "25px",
         color: "#000",
         fontWeight: "bolder",
        }}
        class={`d-flex justify-content-center text-uppercase ${
         lang !== "en" ? "fkr" : "fkp"
        } `}
       >
        {change_Lang("Repayment bills")} ({change_Lang(take_money_view.type)})
       </p>
      </div>
      <div class="col-3 text-right">
       <p
        style={{
         fontSize: "24px",
         color: "#000",
         fontWeight: "bold",
        }}
        class=" text-uppercase"
       >
        {change_Lang("in_invoice")}#&nbsp;
        {take_money_view.invoice_No}&nbsp;
       </p>
      </div>
     </div>
     {/* first row */}
     <div
      class="row mt-1"
      style={{ width: "100%", backgroundColor: "#f4f4f6" }}
     >
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        وەرگر/المستلم :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fkr col-form-label d-flex justify-content-start"
        style={{
         fontSize: "21px",
         color: "#000",
        }}
       >
        {take_money_view.Money_recive}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkb"
       >
        : Receipt from
       </label>
      </div>
     </div>
     {/* second row */}
     <div class="row" style={{ width: "100%", backgroundColor: "white" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        بڕی پارە/مبلغ و قدره :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <NumberFormat
        displayType="text"
        thousandSeparator={true}
        value={take_money_view.Amount}
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        className="col-form-label"
        prefix={`${take_money_view.currency === "dolar" ? "$" : "ID"}`}
       />
       &nbsp;&nbsp;
       <span
        className="fkr"
        style={{
         fontWeight: "bold",
         marginTop: "12px",
         color: "#000",
         fontSize: 18,
        }}
       >
        {" "}
        {lang === "krd" ? numberWordsSorani : numWords1}&nbsp;
        {`${
         take_money_view.currency === "dolar"
          ? lang !== "krd"
            ? "دولار امریکي"
            : "دۆلاری ئەمریکی"
          : "دینار"
        }`}
        {change_Lang("Only")}
       </span>
      </div>
      <div class="col-3 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkb"
       >
        : Amount
       </label>
      </div>
     </div>
     {/* third row */}
     <div class="row" style={{ width: "100%", backgroundColor: "#f4f4f6" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        لە بڕی / وذلك عن :
       </label>
      </div>
      <div class="col-8 d-flex justify-content-center">
       {take_money_view.type !== "investor" &&
       take_money_view.instead_of === "" ? (
        <span
         className="fkr d-flex justify-content-center mt-2"
         style={{
          fontSize: "17px",
          color: "#000",
          textAlign: "justify",
         }}
        >
         {take_money_view.type !== "Monthly rent invoice" ? (
          <>
           {change_Lang(take_money_view.type)} (
           {change_Lang(take_money_view.property)})&nbsp;
           {change_Lang("from")}
           &nbsp;({take_money_view.place}) &nbsp;
           {change_Lang("Number")}&nbsp;({take_money_view.num})
          </>
         ) : (
          <>
           {change_Lang(take_money_view.type)} (
           {change_Lang(take_money_view.property)})&nbsp;
           {change_Lang("from")}
           &nbsp;({take_money_view.place}) &nbsp;
           {change_Lang("Number")}&nbsp;({take_money_view.num}
           )<br />
           {change_Lang("from")}&nbsp;
           {take_money_view.from}
           &nbsp;
           {change_Lang("to")}&nbsp;
           {take_money_view.to}
          </>
         )}
        </span>
       ) : (
        <span
         className="fkr d-flex justify-content-center mt-2"
         style={{
          fontSize: "17px",
          color: "#000",
          textAlign: "justify",
         }}
        >
         {take_money_view && take_money_view.instead_of}
        </span>
       )}
      </div>
      <div class="col-1 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkb"
       >
        : For
       </label>
      </div>
     </div>
     {/* five row */}
     <div class="row" style={{ width: "100%", backgroundColor: "white" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        پارەدەر / الدافع :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fkr col-form-label"
        style={{
         fontSize: "21px",
         color: "#000",
        }}
       >
        {take_money_view.Money_provider}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label"
       >
        : Receptor
       </label>
      </div>
     </div>
     {/* note */}
     <div class="row" style={{ width: "100%", backgroundColor: "#f4f4f6" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        تێبینی / الملاحظات :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fkr col-form-label"
        style={{
         fontSize: "21px",
         color: "#000",
        }}
       >
        {take_money_view.note}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label"
       >
        : Note
       </label>
      </div>
     </div>
     {/* six row */}
     <br />
     <br /> <br />
     <div class="row">
      <div class="col-6 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        ({lang === "krd" ? "پارەدەر" : "الدافع"})&nbsp;واژوو / توقيع
       </label>
      </div>
      <div class="col-6 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        ({lang === "krd" ? "پارەوەرگر" : "المستلم"})&nbsp;واژوو / توقيع
       </label>
      </div>
      <div class="col-6 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
         fontWeight: "bold",
        }}
        class=" col-form-label fkr"
       >
        {take_money_view.Money_provider}
       </label>
      </div>
      <div class="col-6 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
         fontWeight: "bold",
        }}
        class=" col-form-label fkr"
       >
        {take_money_view.Money_recive}
       </label>
      </div>
     </div>
     <br />
    </div>
    <br />
    <br />
    {/* Second Invoice */}
    <br />
    <br />
    <br />
    <br />
    <br /> <br />
    <br /> <br />
    <br />
    <br />
    <div>
     <div class="row fkr">
      <div class="col-3">
       <p
        style={{
         fontSize: "24px",
         color: "#000",
         textAlign: "right",
         fontWeight: "bold",
        }}
        class=" text-uppercase"
       >
        &nbsp;&nbsp;{change_Lang("date")} &nbsp;:&nbsp;
        <Time
         value={take_money_view.createdAt}
         format="YYYY-MM-DD"
         style={{
          fontSize: "24px",
          color: "#000",
          fontWeight: "bold",
         }}
        />
       </p>
      </div>
      <div class="col-6 d-flex justify-content-center">
       <p
        style={{
         fontSize: "25px",
         color: "#000",
         fontWeight: "bolder",
        }}
        class={`d-flex justify-content-center text-uppercase ${
         lang !== "en" ? "fkr" : "fkp"
        } `}
       >
        {change_Lang("Repayment bills")} ({change_Lang(take_money_view.type)})
       </p>
      </div>
      <div class="col-3 text-right">
       <p
        style={{
         fontSize: "24px",
         color: "#000",
         fontWeight: "bold",
        }}
        class=" text-uppercase"
       >
        {change_Lang("in_invoice")}#&nbsp;
        {take_money_view.invoice_No}&nbsp;
       </p>
      </div>
     </div>
     {/* first row */}
     <div
      class="row mt-1"
      style={{ width: "100%", backgroundColor: "#f4f4f6" }}
     >
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        وەرگر/المستلم :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fkr col-form-label d-flex justify-content-start"
        style={{
         fontSize: "21px",
         color: "#000",
        }}
       >
        {take_money_view.Money_recive}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkb"
       >
        : Receipt from
       </label>
      </div>
     </div>
     {/* second row */}
     <div class="row" style={{ width: "100%", backgroundColor: "white" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        بڕی پارە/مبلغ و قدره :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <NumberFormat
        displayType="text"
        thousandSeparator={true}
        value={take_money_view.Amount}
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        className="col-form-label"
        prefix={`${take_money_view.currency === "dolar" ? "$" : "ID"}`}
       />
       &nbsp;&nbsp;
       <span
        className="fkr"
        style={{
         fontWeight: "bold",
         marginTop: "12px",
         color: "#000",
         fontSize: 18,
        }}
       >
        {" "}
        {lang === "krd" ? numberWordsSorani : numWords1}&nbsp;
        {`${take_money_view.currency === "dolar" ? "دۆلاری ئەمریکی" : "دینار"}`}
        {change_Lang("Only")}
       </span>
      </div>
      <div class="col-3 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkb"
       >
        : Amount
       </label>
      </div>
     </div>
     {/* third row */}
     <div class="row" style={{ width: "100%", backgroundColor: "#f4f4f6" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        لە بڕی / وذلك عن :
       </label>
      </div>
      <div class="col-8 d-flex justify-content-center">
       {take_money_view.type !== "investor" &&
       take_money_view.instead_of === "" ? (
        <span
         className="fkr d-flex justify-content-center mt-2"
         style={{
          fontSize: "17px",
          color: "#000",
          textAlign: "justify",
         }}
        >
         {take_money_view.type !== "Monthly rent invoice" ? (
          <>
           {change_Lang(take_money_view.type)} (
           {change_Lang(take_money_view.property)})&nbsp;
           {change_Lang("from")}
           &nbsp;({take_money_view.place}) &nbsp;
           {change_Lang("Number")}&nbsp;({take_money_view.num})
          </>
         ) : (
          <>
           {change_Lang(take_money_view.type)} (
           {change_Lang(take_money_view.property)})&nbsp;
           {change_Lang("from")}
           &nbsp;({take_money_view.place}) &nbsp;
           {change_Lang("Number")}&nbsp;({take_money_view.num}
           )
           <br />
           {change_Lang("from")}&nbsp;
           {take_money_view.from}
           &nbsp;
           {change_Lang("to")}&nbsp;
           {take_money_view.to}
          </>
         )}
        </span>
       ) : (
        <span
         className="fkr d-flex justify-content-center mt-2"
         style={{
          fontSize: "17px",
          color: "#000",
          textAlign: "justify",
         }}
        >
         {take_money_view && take_money_view.instead_of}
        </span>
       )}
      </div>
      <div class="col-1 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkb"
       >
        : For
       </label>
      </div>
     </div>
     {/* five row */}
     <div class="row" style={{ width: "100%", backgroundColor: "white" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        پارەدەر / الدافع :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fkr col-form-label"
        style={{
         fontSize: "21px",
         color: "#000",
        }}
       >
        {take_money_view.Money_provider}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label"
       >
        : Receptor
       </label>
      </div>
     </div>
     {/* note */}
     <div class="row" style={{ width: "100%", backgroundColor: "#f4f4f6" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        تێبینی / الملاحظات :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fkr col-form-label"
        style={{
         fontSize: "20px",
         color: "#000",
        }}
       >
        {take_money_view.note}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label"
       >
        : Note
       </label>
      </div>
     </div>
     {/* six row */}
     <div
      class="row"
      style={{ width: "100%", position: "absolute", bottom: 5 }}
     >
      <div class="col-6 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        ({lang === "krd" ? "پارەدەر" : "الدافع"})&nbsp;واژوو / توقيع
       </label>
      </div>
      <div class="col-6 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        ({lang === "krd" ? "پارەوەرگر" : "المستلم"})&nbsp;واژوو / توقيع
       </label>
      </div>
      <div class="col-6 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
         fontWeight: "bold",
        }}
        class=" col-form-label fkr"
       >
        {take_money_view.Money_provider}
       </label>
      </div>
      <div class="col-6 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
         fontWeight: "bold",
        }}
        class=" col-form-label fkr"
       >
        {take_money_view.Money_recive}
       </label>
      </div>
     </div>
    </div>
   </Fragment>
  );
 }
}

const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  take_money_view: state.Invoice_Reducer.take_money_view,
  index_takemoney: state.Invoice_Reducer.index_takemoney,
  user: state.AuthReducer.user,
  primarycolor: state.HelperReducer.primarycolor,
  secondarycolor: state.HelperReducer.secondarycolor,
  primary_logo_bill: state.HelperReducer.primary_logo_bill,
  footer_logo_bill: state.HelperReducer.footer_logo_bill,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
 };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrintViewTakemoney);
